import type { IAddTransportMarkerOptions } from 'shared/utils/maps/types.ts';
import { EMarkersZIndexes } from 'shared/utils/maps/types.ts';
import styles from './transport-markers.module.scss';

export const addTransportMarker = ({
  map,
  title,
  extraData,
  position,
  type,
  trailerPlateNumber,
  warning = false,
}: IAddTransportMarkerOptions): google.maps.marker.AdvancedMarkerElement => {
  const mainTag = document.createElement('div');
  const iconSpan = document.createElement('span');
  const titleSpan = document.createElement('span');

  mainTag.className = styles.transportTag;
  if (warning) {
    mainTag.classList.add(styles.warning);
  }

  mainTag.appendChild(iconSpan);
  mainTag.appendChild(titleSpan);

  titleSpan.className = styles.titleSpan;
  titleSpan.textContent = `${title}${trailerPlateNumber ? ` / ${trailerPlateNumber}` : ''}`;

  switch (type) {
    case 'truck':
      iconSpan.textContent = '🚛';
      break;
    case 'trailer':
      iconSpan.textContent = '🚃';
      break;
  }

  const extraBox = document.createElement('div');
  extraBox.className = styles.extraBox;
  mainTag.appendChild(extraBox);

  const positionLink = document.createElement('a');
  positionLink.href = `http://www.google.com/maps/place/${position.lat},${position.lng}`;
  positionLink.target = '_blank';
  positionLink.textContent = `${position.lat},${position.lng}`;
  extraBox.appendChild(positionLink);

  const showLink = document.createElement('a');
  showLink.className = styles.withLeftMargin;
  showLink.href = `https://www.google.com/maps?q=&layer=c&cbll=${position.lat},${position.lng}`;
  showLink.target = '_blank';
  showLink.textContent = '👁️';
  extraBox.appendChild(showLink);

  if (extraData?.length) {
    extraData.forEach((item) => {
      const extraLine = document.createElement('div');
      extraLine.className = styles.extraLine;
      extraLine.textContent = item;

      extraBox.appendChild(extraLine);
    });
  }

  const markerView = new google.maps.marker.AdvancedMarkerElement({
    map,
    position,
    content: mainTag,
    zIndex: EMarkersZIndexes.TRANSPORT_MARKERS,
  });

  markerView.addListener('click', () => {
    const isOpen = mainTag.classList.contains(styles.open);
    if (isOpen) {
      mainTag.classList.remove(styles.open);
    } else {
      mainTag.classList.add(styles.open);
    }
  });

  return markerView;
};
